module.exports = __webpack_public_path__ + "img/arrow-up-square-triangle.9219f412.svg";